import { Component } from "react";

// Components
import I18n from "Components/Elements/I18n";
import LineChart from "Components/Materials/Charts/LineChart";
import { EFrequency } from "Components/Elements/FrequencyPicker";
import { DashboardChartsDatas } from "Api/SmartSig/Dashboard";

type IProps = {
	frequency: EFrequency;
	data: DashboardChartsDatas;
};
type IState = {};

export default class ValidatedAnchors extends Component<IProps, IState> {
	override render() {
		return (
			<LineChart
				frequency={this.props.frequency}
				title={I18n.translate("pages.dashboard.widgets.validated_anchor")}
				data={{currentTotal: this.props.data.valid.currentTotal, previousTotal: this.props.data.valid.previousTotal, xaxis: this.props.data.xaxis}}
				qte={this.props.data.valid.previousTotal.length > 0 ? this.props.data.valid.previousTotal[this.props.data.valid.previousTotal.length - 1]! : 0}
			/>
		);
	}

	override componentDidMount() {
		// TODO: Fetch data from API and pass it to the chart
	}
}
